module.exports = __webpack_public_path__ + "img/neteller.c8872b93.svg";